import * as React from "react";
import { CornerUpLeft } from "lucide-react";
import { useNavigate, useParams } from "react-router";

export const SharepointParentDir: React.FC = () => {
  const { "*": fseIds = "" } = useParams<{ "*": string }>();

  const parentPath = fseIds.split("/").slice(0, -1).join("/");

  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate(parentPath ? `/sharepoint/${parentPath}` : "/sharepoint");
  };

  return (
    <div className="flex cursor-pointer items-center p-4 py-6 hover:bg-gray-100" onClick={handleNavigation}>
      <CornerUpLeft className="mr-2 h-5 w-5 text-gray-500" />
      <span className="font-medium text-gray-500">...</span>
    </div>
  );
};
